(function() {
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-mmenu-add]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.mmenu-card__add-btn');
    if (btn.disabled) return;
    btn.disabled = true;
    var origHTML = btn.innerHTML;
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5" fill="none" stroke-dasharray="12 20" class="mmenu-spin"/></svg>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(form.querySelector('[name="id"]').value),
        quantity: 1
      })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8l4 4 6-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Added';
      btn.style.cssText = 'background:#00b5e3;color:#fff;border-color:#00b5e3';

      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var countEl = document.querySelector('.cart-link__bubble-num, [data-cart-count]');
        if (countEl) countEl.textContent = cart.item_count;
        var bubble = document.querySelector('.cart-link__bubble');
        if (bubble) bubble.classList.add('cart-link__bubble--visible');
      });

      setTimeout(function() {
        btn.innerHTML = origHTML;
        btn.disabled = false;
        btn.style.cssText = '';
      }, 2000);
    })
    .catch(function() {
      btn.innerHTML = origHTML;
      btn.disabled = false;
    });
  });

  var s = document.createElement('style');
  s.textContent = '@keyframes mmenu-spin{to{transform:rotate(360deg)}}.mmenu-spin{animation:mmenu-spin .6s linear infinite;transform-origin:center}';
  document.head.appendChild(s);
})();
